import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const checkboxGroupDefaultVariants = {}
const checkboxGroupCompoundVariants = []

const checkboxGroupSlotNames = [
  [
    "group",
    "CheckboxGroup__group"
  ],
  [
    "label",
    "CheckboxGroup__label"
  ],
  [
    "message",
    "CheckboxGroup__message"
  ]
]
const checkboxGroupSlotFns = /* @__PURE__ */ checkboxGroupSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, checkboxGroupDefaultVariants, getSlotCompoundVariant(checkboxGroupCompoundVariants, slotName))])

const checkboxGroupFn = memo((props = {}) => {
  return Object.fromEntries(checkboxGroupSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const checkboxGroupVariantKeys = [
  "error",
  "disabled"
]
const getVariantProps = (variants) => ({ ...checkboxGroupDefaultVariants, ...compact(variants) })

export const checkboxGroup = /* @__PURE__ */ Object.assign(checkboxGroupFn, {
  __recipe__: false,
  __name__: 'checkboxGroup',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: checkboxGroupVariantKeys,
  variantMap: {
  "error": [
    "true"
  ],
  "disabled": [
    "true"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, checkboxGroupVariantKeys)
  },
  getVariantProps
})